import { render } from "./PreparerDropdown.vue?vue&type=template&id=63749e47"
import script from "./PreparerDropdown.vue?vue&type=script&lang=js"
export * from "./PreparerDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__